import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaPinterestP,
} from "react-icons/fa";



const Footer = (props) => {
  return (
    <>
      <div className="row align-items-center">
        <div className="col-md-6 my-2 body">
          {/* <div className="nav justify-content-center text-center text-md-left justify-content-md-start" style={{border:"1px solid red"}}> */}
          <div className="nav" style={{display:"flex", justifyContent:"space-between"}}>
              <h2 className="text-color-site">{props.site.siteTitle}</h2>
          </div>
          {props.site.email !== null && props.site.email !== ""
          ?
          <div className="" style={{display:"flex", justifyContent:"space-between"}}>
              <h4 style={{fontSize:"0.9rem"}} className="text-color-site" >{props.site.email}</h4>
          </div>
          :
          <></>
          }

          {props.site.phoneNumber !== null && props.site.phoneNumber !== ""
          ?
          <div className="" style={{display:"flex", justifyContent:"space-between"}}>
              <h4 style={{fontSize:"0.9rem"}} className="text-color-site" >{props.site.phoneNumber}</h4>
          </div>
          :
          <></>
          }
          {(props.site.addressNumberName === null || props.site.addressNumberName === "") && (props.site.addressFirstLine === null || props.site.addressFirstLine === "") && (props.site.addressPostcode === null || props.site.addressPostcode === "")
          ?
          <></>
          :
          <div className="" style={{display:"flex", justifyContent:"space-between"}}>
              <h4 style={{fontSize:"0.9rem"}} className="text-color-site" >
                {((props.site.addressNumberName !== null) && (props.site.addressNumberName !== "")) ? props.site.addressNumberName + ", " : ""}
                {((props.site.addressFirstLine !== null) && (props.site.addressFirstLine !== "")) ? props.site.addressFirstLine + ", ": ""}
                {((props.site.addressSecondLine !== null) && (props.site.addressSecondLine !== "")) ? props.site.addressSecondLine + ", ": ""}
                {((props.site.addressCity !== null) && (props.site.addressCity !== "")) ? props.site.addressCity + ", ": ""}
                {((props.site.addressCounty !== null) && (props.site.addressCounty !== "")) ? props.site.addressCounty + ", ": ""}
                {((props.site.addressPostcode !== null) && (props.site.addressPostcode !== "")) ? props.site.addressPostcode : ""}

              </h4>
          </div>
          }
          {
            props.site.showBusinessHours
            ?
          <div style={{fontSize:"0.9rem"}}>
          <div className="" style={{display:"flex", justifyContent:"space-between", fontSize:"0.9rem"}}>
              <h4 style={{fontSize:"0.9rem"}} className="text-color-site" >Monday</h4>
              {props.site.mondayOpen === null ? "Closed" : props.site.mondayOpen.hour +":"+props.site.mondayOpen.mins +"-"+ props.site.mondayClose.hour +":"+props.site.mondayClose.mins}
          </div>
          <div className="" style={{display:"flex", justifyContent:"space-between"}}>
              <h4 style={{fontSize:"0.9rem"}} className="text-color-site" >Tuesday</h4>
              {props.site.tuesdayOpen === null ? "Closed" : props.site.tuesdayOpen.hour +":"+props.site.tuesdayOpen.mins +"-"+ props.site.tuesdayClose.hour +":"+props.site.tuesdayClose.mins}
          </div>
          <div className="" style={{display:"flex", justifyContent:"space-between"}}>
              <h4 style={{fontSize:"0.9rem"}} className="text-color-site" >Wednesday</h4>
              {props.site.wednesdayOpen === null ? "Closed" : props.site.wednesdayOpen.hour +":"+props.site.wednesdayOpen.mins +"-"+ props.site.wednesdayClose.hour +":"+props.site.wednesdayClose.mins}
          </div>
          <div className="" style={{display:"flex", justifyContent:"space-between"}}>
              <h4 style={{fontSize:"0.9rem"}} className="text-color-site" >Thursday</h4>
              {props.site.thursdayOpen === null ? "Closed" : props.site.thursdayOpen.hour +":"+props.site.thursdayOpen.mins +"-"+ props.site.thursdayClose.hour +":"+props.site.thursdayClose.mins}
          </div>
          <div className="" style={{display:"flex", justifyContent:"space-between"}}>
              <h4 style={{fontSize:"0.9rem"}} className="text-color-site" >Friday</h4>
              {props.site.fridayOpen === null ? "Closed" : props.site.fridayOpen.hour +":"+props.site.fridayOpen.mins +"-"+ props.site.fridayClose.hour +":"+props.site.fridayClose.mins}
          </div>
          <div className="" style={{display:"flex", justifyContent:"space-between"}}>
              <h4 style={{fontSize:"0.9rem"}} className="text-color-site" >Saturday</h4>
              {props.site.saturdayOpen === null ? "Closed" : props.site.saturdayOpen.hour +":"+props.site.saturdayOpen.mins +"-"+ props.site.saturdayClose.hour +":"+props.site.saturdayClose.mins}
          </div>
          <div className="" style={{display:"flex", justifyContent:"space-between"}}>
              <h4 style={{fontSize:"0.9rem"}} className="text-color-site" >Sunday</h4>
              {props.site.sundayOpen === null ? "Closed" : props.site.sundayOpen.hour +":"+props.site.sundayOpen.mins +"-"+ props.site.sundayClose.hour +":"+props.site.sundayClose.mins}
          </div>
          </div>
          :
          <>
          </>
}
          

          </div>
        {/* End .col */}

        {/* <div className="col-md-6 my-2 text-center text-md-right">
          <p>
            © {new Date().getFullYear()} copyright{" "}
            <a
              href="https://themeforest.net/user/ib-themes/portfolio"
              target="_blank"
              rel="noreferrer"
            >
              ib-themes
            </a>
            all right reserved
          </p>
        </div> */}
        {/* End .col */}
      </div>
      {/* End .row */}
    </>
  );
};

export default Footer;

            {/* {SocialShare.map((val, i) => (
              <a key={i} href={`${val.link}`} rel="noreferrer" target="_blank">
                {val.Social}
              </a>
            ))} */}